import { render, staticRenderFns } from "./Num.vue?vue&type=template&id=1adc9057&"
import script from "./Num.vue?vue&type=script&lang=js&"
export * from "./Num.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports